import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { NgbActiveModal, NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { Subject, forkJoin } from "rxjs";
import { ServiceRequestResponseTypeUtil } from "src/app/shared/utils/service-request-response.utils";
import { GeneralHistoryModel, HistoryClient, RegisterSignalClient, RegisteredSignal, RequestorSignalClient, ServiceRequestResponseTypes, SignalRequestor, SignalStatus, SignalStatusClient, TipAvaria, TipAvariaClient, UserProfile, WorkingGroupClient, WorkingGroups } from "src/app/web-api-client";
import { WtStorageService } from "src/app/wt-storage.service"; 
import { DateTimeUtils } from "src/app/shared/utils/date-time.utils"; 
import { SearchCountryField, CountryISO, PhoneNumberFormat } from 'ngx-intl-tel-input-gg';
import { PhoneNumberUtils } from "src/app/shared/utils/phone-number.utils";
import { ToastrService } from "ngx-toastr";
import { SignalStatusTypes } from "../../modules/vik/enums/signal-status.enum";
import { UserProfessionTypes } from "../../modules/vik/enums/user-professions.enum";
import { PhoneNumber, SignalRequestFormData } from "../../modules/vik/components/modals/add-signal-registration/add-signalRegistration.component";
import { WorkingGroupTypes } from "../../modules/vik/enums/working-groups.enum";



@Component({
  selector: 'app-anona-signal',
  templateUrl: './anona-signal.component.html',
  styleUrls: ['./anona-signal.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush
})
export class AnonaSignalComponent implements OnInit {


  /**
   * If this field is populated it means that the modal is used in edit mode.
   * Otherwise the modal is in ADD mode.
   */
  public registeredSignal: RegisteredSignal = null;
  public phoneNumber = '897112233';
  public userProfile: UserProfile;

  public avariaTypesList: TipAvaria[] = []; 

  public form: FormGroup;
  public phoneFieldEnabled = true;
  public loading = false;

  public signalStatusTypes = SignalStatusTypes;
  public formPhysicalCheckBtnName = 'signalPhysicalCheck';
  public formRegisterIncidentBtnName = 'registerIncident';
  public formNoIncidentBtnName = 'noIncident';

  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  PhoneNumberFormat = PhoneNumberFormat;

  public responseTypes = ServiceRequestResponseTypeUtil.formKeyValueList();
 
  private signalStatusesList: SignalStatus[] = [];
  public generalHistory: GeneralHistoryModel[] = [];


  files: File[] = [];

  constructor(
    private readonly fb: FormBuilder,
    private readonly signalStatusService: SignalStatusClient,
    private readonly tipAvariaService: TipAvariaClient,
    private readonly signalRequestorService: RequestorSignalClient,
    private readonly registerSignalService: RegisterSignalClient,
    private readonly changeDetectorRef: ChangeDetectorRef,
    private readonly workingGroupClient: WorkingGroupClient,
    private readonly localStorage: WtStorageService, 
    private toastr: ToastrService,
    private readonly historyClient: HistoryClient
  ) { }

  ngOnInit(): void {
    this.userProfile = this.localStorage.getuser();
    if (this.registeredSignal) {
      console.log(this.registeredSignal);
      this.normalizeTheRegisteredSignal();
    }

    this.loadNomenclatures();
  }
   
    

  public get isUserDispatcher(): boolean {
    return true
  }
  
  get positiveSignalStatus(): SignalStatus {
    return this.signalStatusesList.find(d => d.id == 1);
  }
   

  get incidentLocation(): google.maps.LatLngLiteral | null {
    if (!this.registeredSignal) {
      return null;
    }

    return {
      lat: +this.registeredSignal.latitude,
      lng: +this.registeredSignal.longitude
    }
  }

  /**
   * Called upon pressing any of the from buttons which are of type "Submit"
   * The logic is handled based on the Button ID and/or the user role.
   *
   * @param $event the browser generated event.
   */
  public onSubmit($event: SubmitEvent) {
    const submitID = (<HTMLButtonElement>$event.submitter).name;
    if (!submitID) {
      return;
    }

    if (this.isUserDispatcher) {
      const signalStatusIsPositive = (+submitID === this.positiveSignalStatus.id);
      this.form.patchValue({
        positiveSignalStatus: signalStatusIsPositive,
        signalStatusId: signalStatusIsPositive ? SignalStatusTypes.ACCEPTED : SignalStatusTypes.FALSE_ALARM
      });
    }  

    this.saveSignal(submitID);
  }

  public onLocationUpdated($event: google.maps.LatLngLiteral) {
    this.form.patchValue({
      position: $event
    });
  }

  

  public onFilesSelect(event: any) {
    this.files.push(...event.addedFiles);
  }

  public onFileRemove(event: any) {
    this.files.splice(this.files.indexOf(event), 1);
  }

  public getCyrilicRequestType(requestType: ServiceRequestResponseTypes): string {
    return ServiceRequestResponseTypeUtil.getCyrilicLabel(requestType);
  }
   
  public getStatus() {
    return this.registeredSignal?.signalStatus.title;
  }


  public GetRemGroupaTitle(item: WorkingGroups): string {

    let manager = '';

    if (item.manager) {
      manager = ` (${item.manager.firstName} ${item.manager.fammilyName})`
    }

    return `${item.title}${manager}`;
  }

   

  private normalizeTheRegisteredSignal() {
    if (!this.registeredSignal) {
      return;
    }

    if (this.registeredSignal.checkoutWhen && DateTimeUtils.isDateCorrupted(this.registeredSignal.checkoutWhen)) {
      this.registeredSignal.checkoutWhen = null;
    }
  }

  private getSignalCloseEmployeeFromSubmitButtonClicked(submitID: string): number {

    let closeEmployeeId: number = null;
    if (submitID === this.formNoIncidentBtnName || submitID === this.formRegisterIncidentBtnName) {
      closeEmployeeId = this.userProfile.id;
    }

    return closeEmployeeId;
  }

  private getSignalCloseDateFromSubmitButtonClicked(submitID: string): Date {

    let closeDate: Date = null;
    if (submitID === this.formNoIncidentBtnName || submitID === this.formRegisterIncidentBtnName) {
      closeDate = new Date();
    }

    return closeDate;
  }

  private getSignalStatusWhenFormSubmitButtonClicked(submitID: string): SignalStatusTypes {
    let signalStatusID = SignalStatusTypes.ACCEPTED;

    if (submitID === this.formPhysicalCheckBtnName) {
      signalStatusID = SignalStatusTypes.CHECKING;
    } else if (submitID === this.formRegisterIncidentBtnName) {
      signalStatusID = SignalStatusTypes.CLOSED_ISSUE_IDENTIFIED;
    } else if (submitID === this.formNoIncidentBtnName) {
      signalStatusID = SignalStatusTypes.CLOSED_ISSUE_NOT_IDENTIFIED;
    }

    return signalStatusID;
  }

  /**
   * Initial form values based on weather we are adding or editting a signal.
   */
  private initializeForm() {
      
    const firstName = this.registeredSignal?.signalRequestor?.name || 'Няма Въведен';
    const middleName = this.registeredSignal?.signalRequestor?.middleName || 'Няма Въведен';
    const lastName = this.registeredSignal?.signalRequestor?.fammily || 'Няма Въведен';
    const responseType = this.registeredSignal?.responseType || ServiceRequestResponseTypes.None;
    let title = this.registeredSignal?.title || '';
    const avariaTypeId = this.registeredSignal?.idTipAvaria || 0;
    const signalStatusId = this.registeredSignal?.signalStatusId || 0;
    const workGroupId = this.registeredSignal?.workingGroupsId || WorkingGroupTypes.NONE;
    const whenDate = DateTimeUtils.toFormLocalDateTime(this.registeredSignal?.when || null);
    const checkoutWhen = DateTimeUtils.toFormLocalDateTime(this.registeredSignal?.checkoutWhen || null);
    const description = this.registeredSignal?.description || '';
    const checkoutAdittionalInfo = this.registeredSignal?.checkoutAdittionalInfo || '';
    const position: google.maps.LatLngLiteral = this.registeredSignal != null
      ? { lat: +this.registeredSignal.latitude, lng: +this.registeredSignal.longitude }
      : null;

    let selectedAvariaTypeTitle = avariaTypeId ? this.avariaTypesList.find(d => d.id == avariaTypeId).title : ' ';

    title = !title || title == ' ' ? selectedAvariaTypeTitle : title;

    this.form = this.fb.group({
      phoneNumber: [{ value: this.phoneNumber }],
      firstName: [{ value: firstName, disabled: false }],
      middleName: [{ value: middleName, disabled: false }],
      lastName: [{ value: lastName, disabled: false }],
      email: [{ value: 'nomail@mail.com', disabled: false }],
      responseType: [{ value: responseType, disabled: false }],
      title: [{ value: title, disabled: false }, Validators.required],
      avariaType: [{ value: avariaTypeId, disabled: false }, Validators.required],
      wGroup: [{ value: workGroupId }],
      whenDateTime: [{ value: whenDate, disabled: false }],
      description: new FormControl({ value: description, disabled: false }),
      position: [position, Validators.required],
      signalStatusId: [signalStatusId]
    });

   

     
  }

  private loadNomenclatures() {
    this.loading = true;

    forkJoin([
      this.tipAvariaService.getList(), 
      this.signalStatusService.getList()
    ]).subscribe(([avariaTypesList, signalStatusesList]) => {
      this.avariaTypesList = avariaTypesList; 
      this.signalStatusesList = signalStatusesList;
 


      this.initializeForm();


      this.loading = false;
      this.changeDetectorRef.detectChanges();
    });
  }

  private enableSignalInitiatorFormNamesFields() {
    this.form.controls.firstName.enable();
    this.form.controls.middleName.enable();
    this.form.controls.lastName.enable();
    this.form.controls.email.enable();
  }

  private disableSignalInitiatorFormNamesFields() {
    this.form.controls.firstName.disable();
    this.form.controls.middleName.disable();
    this.form.controls.lastName.disable();
    this.form.controls.email.disable();
  }

  private disableAndResetSignalInitiatorFormNamesFields() {
    this.form.patchValue({
      firstName: '',
      middleName: '',
      lastName: '',
      email: ''
    });

    this.disableSignalInitiatorFormNamesFields();
  }

  private enableAndResetSignalInitiatorFormPhoneField() {
    this.form.patchValue({
      phoneNumber: 0,
    });
    this.form.controls.phoneNumber.enable();
  }

  private disableSignalInitiatorFormPhoneField() {
    this.form.controls.phoneNumber.disable();
  }

  private setSelectedSignalRequestorFormFieldNames(signalRequestor: SignalRequestor) {
    if (signalRequestor) {
      this.form.patchValue({
        firstName: signalRequestor.name,
        middleName: signalRequestor.middleName,
        lastName: signalRequestor.fammily,
        email: signalRequestor.email,
      });
    }
  }

  private buildSignalRequestorFromFormData(): SignalRequestor {
    const formValues = this.form.getRawValue() as SignalRequestFormData;
    let phoneNumberObj = formValues.phoneNumber;

    if (!phoneNumberObj) {
      phoneNumberObj =
        {
        countryCode: '+359',
        dialCode: '000',
        e164Number: '01',
        internationalNumber: '',
        nationalNumber: '+359',
        number: this.phoneNumber
        } as PhoneNumber;


      phoneNumberObj.number = this.phoneNumber;
    }

    const signalRequestor = new SignalRequestor();
    signalRequestor.phoneNumber = PhoneNumberUtils.removeNonDigitsFromPhoneNumber(phoneNumberObj.e164Number);

 
      signalRequestor.id = 0;
      signalRequestor.name = formValues.firstName;
      signalRequestor.middleName = formValues.middleName;
      signalRequestor.fammily = formValues.lastName;
      signalRequestor.email = formValues.email;
   
    return signalRequestor;
  }

  private buildRegisteredSignalFromFormData(): RegisteredSignal {
    const formValues = this.form.getRawValue() as SignalRequestFormData;
    console.log(formValues);

    let registeredSignal = new RegisteredSignal();
    if (this.registeredSignal) {
      registeredSignal = JSON.parse(JSON.stringify(this.registeredSignal));
    }

    registeredSignal.idTipAvaria = formValues.avariaType;
    registeredSignal.responseType = formValues.responseType;
    registeredSignal.title = formValues.title;
    registeredSignal.description = formValues.description;
    registeredSignal.latitude = formValues.position.lat.toString();
    registeredSignal.longitude = formValues.position.lng.toString();
    registeredSignal.when = new Date(formValues.whenDateTime);
    registeredSignal.workingGroupsId = formValues.wGroup;
    registeredSignal.signalStatusId = formValues.signalStatusId;
    registeredSignal.signalRequestor = this.buildSignalRequestorFromFormData();

    

    return registeredSignal;
  }

  private saveSignal(submitId: string) {
    if (this.form.valid) {
      const registeredSignal = this.buildRegisteredSignalFromFormData();

      registeredSignal.closeDate = this.getSignalCloseDateFromSubmitButtonClicked(submitId);
      registeredSignal.closeEmployeeId = this.getSignalCloseEmployeeFromSubmitButtonClicked(submitId);

      if (!registeredSignal.title || registeredSignal.title == ' ') {
        registeredSignal.title = this.avariaTypesList.find(d => d.id == registeredSignal.idTipAvaria).title;
      }

      if (!registeredSignal.checkoutWhen) {
        registeredSignal.checkoutWhen = new Date();
      }

      registeredSignal.when = new Date();
      registeredSignal.workingGroupsId = 0;
 
      
        this.registerSignalService.create(registeredSignal).subscribe(res => {

          this.toastr.success("Успешно Създаден", "Сигнал", {
            timeOut: 3000,
            closeButton: true,
            positionClass: "toast-top-right",
          });  
        });
      
    }
  }


}

